import type { AnalyticsProvider } from '~analytics/types/analyticsProvider';
import type { RuntimeConfig } from 'nuxt/schema';

interface GoogleAnalytics {
  proxy: {
    gtag: (operationType: string, eventName: string, eventData?: object) => void;
  };
}
export default class GoogleAnalyticsProvider implements AnalyticsProvider {
  serviceName: string;
  subscribedEvents: string[];
  googleAnalytics?: GoogleAnalytics;
  mappedEvents: Record<string, string>

  constructor(
    serviceName: string,
    config: RuntimeConfig,
    subscribedEvents: string[],
  ) {
    this.serviceName = serviceName;
    this.subscribedEvents = subscribedEvents;
    this.mappedEvents = {
      PHOENIX_ACCOUNT_REGISTER_COMPLETED: 'sign_up',
      PHOENIX_LEARN_TOPIC_COMPLETED: 'tutorial_complete',
    }
  }

  async init() {
    this.googleAnalytics
      = useScriptGoogleAnalytics() as unknown as GoogleAnalytics;
  }

  track(eventName: string, eventData?: object) {
    const event = this.mappedEvents[<keyof typeof this.mappedEvents>eventName]
      ? this.mappedEvents[<keyof typeof this.mappedEvents>eventName]
      : eventName;
    this.googleAnalytics?.proxy.gtag('event', event ?? eventName, eventData);
  }

  identify() {
    // noop atm
  }

  reset() {
    // noop atm
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  setUserProperties(properties: Record<string, unknown>) {
    // noop atm
  }

  getSubscribedEvents() {
    return this.subscribedEvents;
  }
}
